import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

export function useIsDesktop(): boolean {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.up('md'));
}
